module.exports = __webpack_public_path__ + "img/1F60F.90a7e6a4.svg";